module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/kDGnHa/tc-custom/9781626816688.jpg?1736882001233",
      "alt": "This image is the cover for the book Texas Twilight, Silver Creek Stories"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Texas Twilight, Silver Creek Stories\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("When a young widow reunites with an old flame on her Texas ranch, their love is as boundless as the wide open frontier in this western historical romance.")]), _c('br'), _c('br'), _c('i', [_vm._v("Texas, 1886")]), _vm._v(". When Trace Garrett shows up on Clara Ehler’s Texas ranch, she can hardly believe it’s him—and as handsome as she remembers. Seeing him years ago in New York, he was everything she longed for, and entirely different from the much older man she was pressured into marrying. But now he’s back, and one look at him sets the flame of passion ablaze once again."), _c('br'), _c('br'), _vm._v(" But Trace holds more than the deed to Clara’s heart—he holds the deed to her ranch as well. When her husband died, she planned on selling the ranch and moving back East. But Trace knows the only place for Clara is on the Texas frontier, and in his embrace.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Vivian Vaughan\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Diversion Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0